/* import __COLOCATED_TEMPLATE__ from './enforce-saml-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();